import { type FC, type ReactElement } from 'react';
import { useFragment, graphql } from 'react-relay';

import HeadingLevel, { type HeadingType } from 'dibs-controlled-heading/exports/HeadingLevel';
import { type SharedCreatorsRootHeadingsWrapper_itemSearch$key } from './__generated__/SharedCreatorsRootHeadingsWrapper_itemSearch.graphql';

type Props = {
    itemSearch: SharedCreatorsRootHeadingsWrapper_itemSearch$key;
    showContentModule: boolean;
    children: (arg0?: HeadingType) => ReactElement;
};

export const SharedCreatorsRootHeadingsWrapper: FC<Props> = ({
    itemSearch: itemSearchRef,
    showContentModule,
    children,
}) => {
    const itemSearch = useFragment(
        graphql`
            fragment SharedCreatorsRootHeadingsWrapper_itemSearch on ItemSearchQueryConnection {
                meta {
                    subHeader
                }
            }
        `,
        itemSearchRef
    );
    const isSubHeaderAvailable = !!itemSearch?.meta?.subHeader;
    const wrapTopLevel = isSubHeaderAvailable || showContentModule;
    const additionalHeadingWrapper = isSubHeaderAvailable && showContentModule;
    return wrapTopLevel ? (
        <HeadingLevel>
            {Heading => (
                <>
                    {additionalHeadingWrapper ? (
                        <HeadingLevel>{SubHeading => children(SubHeading)}</HeadingLevel>
                    ) : (
                        children(Heading)
                    )}
                </>
            )}
        </HeadingLevel>
    ) : (
        children()
    );
};
